import { Pipe, PipeTransform } from "@angular/core";
import { LocalizationService } from "../services/localization.service";
import { SubscriptionType, SubscriptionTypeTranslations } from "src/app/core/interfaces/subscription-type.interface";

@Pipe({ name: 'subscriptionType', pure: false })
export class SubscriptionTypePipe implements PipeTransform {
    constructor(private localizationService: LocalizationService) { }

    transform(value: SubscriptionType | string): string {
        if (!value) return '';
        return this.localizationService.getCachedLanguage() === 'ar'
            ? SubscriptionTypeTranslations[value as SubscriptionType] || value
            : value;
    }
}